import { render, staticRenderFns } from "./onboardForm.vue?vue&type=template&id=1872d664&"
import script from "./onboardForm.vue?vue&type=script&lang=js&"
export * from "./onboardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports